export default __webpack_public_path__ + "static/media/Sub_Entity_Icon.be28b5eb.svg";